import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  getClasses,
} from "../api/services";

function SendParentMessage() {

  const [classes, setClasses] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");
  const { t } = useTranslation();

  const [message, setMessage] = useState("");

  const [sending, setSending] = useState(false);

  const [progress, setProgress] = useState(0);

  const [sentCount, setSentCount] = useState(0);

  const [failedCount, setFailedCount] = useState(0);

  const [logs, setLogs] = useState([]);

  const token = localStorage.getItem("access");

  useEffect(() => {
    fetchClasses();
  }, []);

  // =====================================================
  // FETCH CLASSES
  // =====================================================

  const fetchClasses = async () => {

    try {

      const res = await getClasses();

      setClasses(res.data);

    } catch (err) {

      console.error(err);

      alert("Failed to load classes.");
    }
  };

  // =====================================================
  // SEND MESSAGE
  // =====================================================

  const sendMessage = async () => {

    if (!selectedClass) {

      alert("Please select a class.");

      return;
    }

    if (!message.trim()) {

      alert("Please type a message.");

      return;
    }

    try {

      setSending(true);

      setProgress(20);

      const res = await axios.post(
        "https://api.eduskot.com/api/reports/send-parent-message/",
        {
          class_id: selectedClass,
          message: message,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setProgress(100);

      setSentCount(res.data.sent);

      setFailedCount(res.data.failed);

      setLogs(res.data.logs || []);

      alert("Messages sent successfully.");

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.error ||
        "Failed to send messages."
      );

    } finally {

      setSending(false);
    }
  };

  return (

    <div style={styles.page}>

      <div style={styles.card}>

        <h1 style={styles.title}>
          {t("parentCommunicationCenter")}
        </h1>

        <p style={styles.subtitle}>
          {t("parentCommunicationText")}
          {t("and school updates directly to")}
          {t("parents and sponsors")}
        </p>

        {/* CLASS */}

        <div style={styles.field}>

          <label style={styles.label}>
            {t("selectClass")}
          </label>

          <select
            style={styles.select}
            value={selectedClass}
            onChange={(e) =>
              setSelectedClass(e.target.value)
            }
          >

            <option value="">
              -- Select Class --
            </option>

            {classes.map((c) => (

              <option key={c.id} value={c.id}>
    {c["department__name"]
        ? `${c.name} (${c["department__name"]})`
        : c.name}
</option>

            ))}

          </select>

        </div>

        {/* MESSAGE */}

        <div style={styles.field}>

          <label style={styles.label}>
            {t("message")}
          </label>

          <textarea
            style={styles.textarea}
            rows={7}
            placeholder={t("typeMessage")}
            value={message}
            onChange={(e) =>
              setMessage(e.target.value)
            }
          />

        </div>

        {/* PROGRESS */}

        <div style={styles.progressWrapper}>

          <div
            style={{
              ...styles.progressBar,
              width: `${progress}%`,
            }}
          />

        </div>

        <div style={styles.progressText}>
          {progress}% Completed
        </div>

        {/* STATS */}

        <div style={styles.statsRow}>

          <div style={styles.successBox}>
            Sent: {sentCount}
          </div>

          <div style={styles.failedBox}>
            Failed: {failedCount}
          </div>

        </div>

        {/* BUTTON */}

        <button
          style={styles.sendBtn}
          onClick={sendMessage}
          disabled={sending}
        >

          {
            sending
              ? t("sendingMessages")
              : t("sendMessageToParents")
          }

        </button>

        {/* LOGS */}

        {logs.length > 0 && (

          <div style={styles.logsBox}>

            <h3 style={styles.logsTitle}>
              {t("deliveryLogs")}
            </h3>

            {logs.map((log, index) => (

              <div
                key={index}
                style={styles.logItem}
              >

                <strong>
                  {log.student}
                </strong>

                {" — "}

                {log.status}

              </div>

            ))}

          </div>
        )}

      </div>

    </div>
  );
}

const styles = {

  page:{
    padding:"7px",
    background:"linear-gradient(135deg,#eef2ff,#f8fafc)",
    minHeight:"100vh",
    display:"flex",
    justifyContent:"center",
    alignItems:"flex-start",
    fontFamily:"Inter, sans-serif"
  },

  card:{
    width:"100%",
    maxWidth:"800px",
    background:"white",
    padding:"35px",
    borderRadius:"18px",
    boxShadow:"0 20px 50px rgba(0,0,0,0.08)"
  },

  title:{
    fontSize:"30px",
    marginBottom:"10px",
    color:"#0f172a"
  },

  subtitle:{
    color:"#64748b",
    marginBottom:"30px",
    lineHeight:"1.6"
  },

  field:{
    display:"flex",
    flexDirection:"column",
    marginBottom:"20px"
  },

  label:{
    marginBottom:"8px",
    fontWeight:"600",
    color:"#0f172a"
  },

  select:{
    padding:"12px",
    borderRadius:"10px",
    border:"1px solid #cbd5e1"
  },

  textarea:{
    padding:"15px",
    borderRadius:"12px",
    border:"1px solid #cbd5e1",
    resize:"vertical",
    fontSize:"15px",
    fontFamily:"inherit"
  },

  progressWrapper:{
    width:"100%",
    height:"22px",
    background:"#e2e8f0",
    borderRadius:"999px",
    overflow:"hidden",
    marginBottom:"10px"
  },

  progressBar:{
    height:"100%",
    background:"#16a34a",
    transition:"0.4s"
  },

  progressText:{
    marginBottom:"20px",
    color:"#475569",
    fontWeight:"600"
  },

  statsRow:{
    display:"flex",
    gap:"15px",
    marginBottom:"25px"
  },

  successBox:{
    flex:1,
    background:"#dcfce7",
    color:"#166534",
    padding:"14px",
    borderRadius:"12px",
    fontWeight:"700",
    textAlign:"center"
  },

  failedBox:{
    flex:1,
    background:"#fee2e2",
    color:"#991b1b",
    padding:"14px",
    borderRadius:"12px",
    fontWeight:"700",
    textAlign:"center"
  },

  sendBtn:{
    width:"100%",
    padding:"15px",
    background:"#16a34a",
    color:"white",
    border:"none",
    borderRadius:"12px",
    fontWeight:"700",
    fontSize:"16px",
    cursor:"pointer"
  },

  logsBox:{
    marginTop:"30px",
    borderTop:"1px solid #e2e8f0",
    paddingTop:"20px"
  },

  logsTitle:{
    marginBottom:"15px",
    color:"#0f172a"
  },

  logItem:{
    padding:"10px 0",
    borderBottom:"1px solid #f1f5f9",
    color:"#334155"
  }
};

export default SendParentMessage;